import {
  betStatus,
  clearBetStatusResponse,
  clearExchangeBets,
  fetchBalance,
  fetchMultiMarketEventData,
  fetchOpenBets,
  getBookmakerMarketsByEvent,
  getSecondaryMarketsByEvent,
  getSecondaryMatchOddsByEvent,
  setBettingInprogress,
  showToast,
  useAppDispatch,
  useAppSelector,
  BET_TIMEOUT,
  getHouseIdFromToken,
  getParentIdFromToken,
} from "@hypexone/uicore";
import moment from "moment";
import { useCallback, useEffect, useRef, useState } from "react";
import { useMarketLocalState } from "../../../utils/hooks/storage.hooks";
import MultiMarkets from "./MultiMarkets";
import { pnService } from "../../../webSocket/SocketServices";
import { getBaseUrl } from "../../../api/api-services/environment-url/environment-url";
import CommonClient from "@hypexone/uicore/lib/cjs/src/client/reddog/common_client";
import { errorHandler } from "../../../App.utils";

const MultiMarketView = () => {
  const dispatch = useAppDispatch();
  const {
    secondaryMultiMarketsMap: secondaryMultiMarket,
    secondaryMultiMatchOddsMap: secondaryMultiMatchOdds,
    multiMarketData: marketData,
    triggerFetchMarkets,
    triggerFetchOrders,
    triggerBetStatus,
  } = useAppSelector((state) => state.multiMarket);
  const { bets, betStatusResponse } = useAppSelector((state) => state.betSlip);
  const { loggedIn } = useAppSelector((state) => state.auth);
  const { pushNotifWSConnection, topicUrls } = useAppSelector(
    (state) => state.catalog
  );

  const [exposureMap, setExposureMap] = useState(new Map());
  const [enableFetchOrders, setEnableFetchOrders] = useState<boolean>(false);
  const [startTime] = useState<Date>();
  const [fetchOpenOrders, setFetchOpenOrders] = useState<number>(null);
  const [addNewBet] = useState<boolean>(true);
  const intervalRef = useRef(null);
  const isFirstRender = useRef(true);
  const isFirstRenderStartTime = useRef(true);
  // const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const [multiMarketData] = useMarketLocalState();

  const houseId = getHouseIdFromToken();
  const parentId = getParentIdFromToken();
  const accountId = sessionStorage.getItem("aid");

  const SVLS_BASE_URL = getBaseUrl(
    import.meta.env.VITE_NODE_ENV,
    "REACT_APP_REST_API_V2_URL"
  );
  const commonClient = new CommonClient(
    SVLS_BASE_URL,
    sessionStorage.getItem("jwt_token"),
    errorHandler
  );

  const fetchOpenBetsRisk = useCallback(async () => {
    try {
      if (!multiMarketData?.length) {
        return;
      }

      let eventIds = [];
      let marketIds = [];
      multiMarketData.forEach((item) => {
        eventIds.push(item?.eventId);
        marketIds.push(item?.marketId);
      });


      const response = await commonClient.getUserRisk(
        Array.isArray(eventIds) ? eventIds.join(",") : eventIds,
        Array.isArray(marketIds)
          ? marketIds.join(",")
          : marketIds
      );
      setExposureMap(response.data.marketExposureMap);
    } catch (e) {
      console.log(e);
    }
  }, []);

  useEffect(() => {
    dispatch(fetchMultiMarketEventData());
  }, [triggerFetchMarkets]);

  useEffect(() => {
    if (multiMarketData?.length) {
      let eventIds = [];
      multiMarketData.forEach((item) => {
        eventIds.push(item?.eventId);
      });
      dispatch(fetchOpenBets({ eventId: eventIds }));
      fetchOpenBetsRisk();
    }
    setEnableFetchOrders(true);
  }, [multiMarketData]);

  useEffect(() => {
    if (loggedIn && enableFetchOrders && multiMarketData?.length) {
      let eventIds = [];
      multiMarketData.forEach((item) => {
        eventIds.push(item?.eventId);
      });
      setTimeout(() => {
        dispatch(fetchOpenBets({ eventId: eventIds }));
        fetchOpenBetsRisk();
      }, 1000);
    }
  }, [loggedIn, triggerFetchOrders, fetchOpenOrders]);

  // useEffect(() => {
  //   if (totalOrders && !isMobile) {
  //     setTabVal(1);
  //   }
  // }, [totalOrders]);
  // useEffect(() => {
  //   if (bets.length > 0) {
  //     setTabVal(0);
  //   }
  // }, [bets]);

  useEffect(() => {
    if (loggedIn && pushNotifWSConnection) {
      pnService.subscribeWsForNotificationsPerAdmin(
        true,
        houseId,
        parentId,
        accountId
      );
      pnService.subscribeWsForNotifications(true, houseId);
    
    }
  }, [pushNotifWSConnection, loggedIn]);

  useEffect(() => {
    if (betStatusResponse === null) {
      return;
    }

    switch (betStatusResponse.status) {
      case "IN_PROGRESS": {
        dispatch(
          showToast({
            type: "error",
            message: betStatusResponse.message,
          })
        );

        break;
      }
      case "SUCCESS": {
        dispatch(
          showToast({
            type: "success",
            message: betStatusResponse.message,
          })
        );
        if (addNewBet) {
          setFetchOpenOrders(moment.now());
        }
        dispatch(fetchBalance());
        break;
      }
      case "FAIL": {
        dispatch(
          showToast({
            type: "error",
            message: "Bet failed - " + betStatusResponse.message,
          })
        );
        break;
      }
    }

    dispatch(setBettingInprogress(false));
    if (bets[0]?.amount) {
      dispatch(clearExchangeBets());
    }
    dispatch(clearBetStatusResponse());
  }, [betStatusResponse]);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    clearInterval(intervalRef.current);
    dispatch(betStatus());
  }, [triggerBetStatus]);

  useEffect(() => {
    if (isFirstRenderStartTime.current) {
      isFirstRenderStartTime.current = false;
      return;
    }

    intervalRef.current = setInterval(() => {
      dispatch(betStatus());
      clearInterval(intervalRef.current);
    }, BET_TIMEOUT);

    return () => clearInterval(intervalRef.current);
  }, [startTime]);

  useEffect(() => {
    dispatch(setBettingInprogress(false));
    if (bets[0]?.amount) {
      dispatch(clearExchangeBets());
    }
    dispatch(clearBetStatusResponse());
  }, []);
console.log('multi Market Data - ', multiMarketData, "-------", marketData, "--------", secondaryMultiMarket);
  return (
    <>
      <div className="flex justify-between items-center gap-3 text-white bg-black1 px-2 py-1.5 md:py-1">
        Multi Market
      </div>
      {
        multiMarketData?.length && marketData && Object.keys(marketData)?.length
          ? Object.keys(marketData).map((item) => {
            console.log("secccccc --------",secondaryMultiMarket[item].bookmakers);
            console.log("sedddddd --------",getBookmakerMarketsByEvent(
              secondaryMultiMarket,
              item
            ));
            return (
              <MultiMarkets
                key={item}
                topicUrls={topicUrls}
                loggedIn={loggedIn}
                eventData={marketData[item]}
                secondaryMarkets={getSecondaryMarketsByEvent(
                  secondaryMultiMarket,
                  item
                )}
                secondaryMatchOdds={getSecondaryMatchOddsByEvent(
                  secondaryMultiMatchOdds,
                  item
                )}
                bmMData={getBookmakerMarketsByEvent(
                  secondaryMultiMarket,
                  item
                )}
                // eventId={marketData[item]?.eventId}
                isMultiMarket={true}
                exposureMap={exposureMap ? exposureMap : null}
              />
            );
          })
          : null
        // : < MultiMarketDesktop />
      }
      {(multiMarketData?.length === 0 ||
        Object.keys(marketData)?.length === 0) && (
          <div className="no-data multimarket-no-data">
            There are currently no followed multi markets.
          </div>
        )}
    </>
  );
};

export default MultiMarketView;
